module.exports = __webpack_public_path__ + "img/source-sans-pro-v21-latin-300.84184d57.svg";